const DEV_API_URL = "https://dev-api.greentill.co/api/";
const PROD_API_URL = "https://api.greentill.co/api/";

export function getApiUrl() {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  if (typeof window !== "undefined") {
    const host = window.location.hostname;
    if (
      host.includes("dev-cms") ||
      host === "localhost" ||
      host === "127.0.0.1"
    ) {
      return DEV_API_URL;
    }
  }

  return PROD_API_URL;
}
